import { render, staticRenderFns } from "./riepilogoFatture.vue?vue&type=template&id=2781b8fa&scoped=true"
import script from "./riepilogoFatture.vue?vue&type=script&lang=js"
export * from "./riepilogoFatture.vue?vue&type=script&lang=js"
import style0 from "./riepilogoFatture.vue?vue&type=style&index=0&id=2781b8fa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2781b8fa",
  null
  
)

export default component.exports